const PDF_URL_MAP = {
  "511.005.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/511.005.pdf",
  "511.007-1-1.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/511.007-1-1.pdf",
  "511.007-1.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/511.007-1.pdf",
  "512.011-1.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/512.011-1.pdf",
  "512.007-2.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/512.007-2.pdf",
  "512.004.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/512.004.pdf",
  "511.006.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/511.006.pdf",
  "512.009-1.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/653fbe80-e4c5-11ed-95e8-fdb8a484b2c4/docs/512.009-1.pdf",
  "מדריך למתכנן - תכנון ציוד שאיבה בקידוחים.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/cf5f6380-f96d-11ed-829a-3560aa7f7b38/docs/מדריך למתכנן - תכנון ציוד שאיבה בקידוחים.pdf",
  "מבחני שדה למשאבות.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/cf5f6380-f96d-11ed-829a-3560aa7f7b38/docs/מבחני שדה למשאבות.pdf",
  "נוהל פירוק והרכבת משאבות במתקנים.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/cf5f6380-f96d-11ed-829a-3560aa7f7b38/docs/נוהל פירוק והרכבת משאבות במתקנים.pdf",
  "אחסון והובלת חלקי מפוקים לקידוחים.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/cf5f6380-f96d-11ed-829a-3560aa7f7b38/docs/אחסון והובלת חלקי מפוקים לקידוחים.pdf",
  "היכל ומגדל המשפט קובץ ב - קובץ עבודה.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/e90b67c0-fbe7-11ee-9f3c-0d0d8e692821/docs/היכל ומגדל המשפט קובץ ב - קובץ עבודה.pdf",
  "היכל ומגדל המשפט קובץ ג - קובץ עבודה.pdf": "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/e90b67c0-fbe7-11ee-9f3c-0d0d8e692821/docs/היכל ומגדל המשפט קובץ ג - קובץ עבודה.pdf",
  "היכל ומגדל המשפט קובץ ד - קובץ עבודה.pdf" : "https://s3.eu-central-1.amazonaws.com/qa.bimmatch-storage.eu-central-1/organizations/e90b67c0-fbe7-11ee-9f3c-0d0d8e692821/docs/היכל ומגדל המשפט קובץ ד - קובץ עבודה.pdf"
}

export function formatBotMessage(text) {
  let safeText = sanitizeText(text); // You must define this function securely

  // Headings: # to ######
  safeText = safeText.replace(/^######\s*(.*)$/gm, '<h6>$1</h6>');
  safeText = safeText.replace(/^#####\s*(.*)$/gm, '<h5>$1</h5>');
  safeText = safeText.replace(/^####\s*(.*)$/gm, '<h4>$1</h4>');
  safeText = safeText.replace(/^###\s*(.*)$/gm, '<h3>$1</h3>');
  safeText = safeText.replace(/^##\s*(.*)$/gm, '<h2>$1</h2>');
  safeText = safeText.replace(/^#\s*(.*)$/gm, '<h1>$1</h1>');

  // Bold-italic (***text***)
  safeText = safeText.replace(/\*\*\*(.*?)\*\*\*/g, '<strong><em>$1</em></strong>');

  // Bold (**text**)
  safeText = safeText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  // Italic (*text*)
  safeText = safeText.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>');

  // Convert bullet points (• item)
  safeText = safeText.replace(/(?:^|\n)•\s(.+)/g, '\n<li>$1</li>');

  // Convert numbered lists (1. item)
  safeText = safeText.replace(/(?:^|\n)\d+\.\s(.+)/g, '\n<ol-li>$1</ol-li>');

  // Group <li> into <ul>
  safeText = safeText.replace(/(?:<li>.*?<\/li>\s*)+/gs, match => {
    const items = match.match(/<li>.*?<\/li>/g);
    return items ? `<ul>${items.join('')}</ul>` : match;
  });

  // Group numbered <ol-li> into <ol>
  safeText = safeText.replace(/(?:<ol-li>.*?<\/ol-li>\s*)+/gs, match => {
    const items = match.match(/<ol-li>.*?<\/ol-li>/g);
    return items
      ? `<ol>${items.map(i => i.replace(/<ol-li>/, '<li>').replace(/<\/ol-li>/, '</li>')).join('')}</ol>`
      : match;
  });

  // Ensure exactly one newline after heading
  safeText = safeText.replace(/(<\/h[1-6]>)[ \t]*\n+/g, '$1');

  // Convert remaining newlines into <br>
  safeText = safeText.replace(/\n/g, '<br>');

  // PDF refrences

  // English support format ([Document name, page PAGE_NUMBER](link-to-pdf-NUMBER)) 
  // Hebrew Support format ([מדריך למתכנן - תכנון ציוד שאיבה בקידוחים, דף 17-21](link-to-pdf-1))
  const refRegex = /\(\[([^,\]]+)(?:, [^,\] ]+ ([^,\]]+))?(?:, Section ([^\]]+))?\]\(link-to-pdf-([^)]+)\)\)/gi
  safeText = safeText.replace(refRegex, (m, sourceRaw, pageRaw, sectionRaw, linkId) => {

  let source = (sourceRaw || '').trim();
  if (!/\.pdf$/i.test(source)) source += '.pdf';

  const page = pageRaw ? parseInt(pageRaw, 10) : '';
  const section = sectionRaw ? sectionRaw.trim() : '';

  const directUrl = resolveUrlForFile(source); // lookup from PDF_URL_MAP

  const label = [
    'REF: ' + source,
    page ? 'PAGE: ' + page : null,
    section ? 'Section ' + section : null
  ].filter(Boolean).join(', ');

  const pdfAttr = { Bucket: "qa.bimmatch-storage.eu-central-1", Key: directUrl.split("/qa.bimmatch-storage.eu-central-1/")[1]}

  return `<div class="ref-link-chat"
            data-file="${source}"
            data-page="${page}"
            data-url="${directUrl || ''}"
            data-bucket=${pdfAttr.Bucket}
            data-key=${encodeURIComponent(pdfAttr.Key)}
            data-section="${encodeURIComponent(section)}"
            >${label}</div>`;
});

  return safeText;
}

function normFileKey(name) {
  return (name || "")
    .replace(/\.pdf$/i, "")
    .replace(/[\s\-\u200f\u200e]/g, "")
    .toLowerCase();
}

function resolveUrlForFile(fileName) {
  if (!fileName) return null;
  // 1) exact
  console.log("fileName", fileName);
  
  if (PDF_URL_MAP[fileName]) return PDF_URL_MAP[fileName];

  // 2) normalized (handles RTL marks / dashes / spaces / case)
  const key = normFileKey(fileName) + ".pdf";
  console.log(" normFileKey key", key);
  for (const k of Object.keys(PDF_URL_MAP)) {
    if (normFileKey(k) + ".pdf" === key) return PDF_URL_MAP[k];
  }
  return null;
}

function sanitizeText(text) {
  // Sanitize text to prevent XSS while preserving safe formatting
  return text.replace(/[&<>"']/g, function (match) {
    const escape = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    return escape[match];
  });
}